import { render, staticRenderFns } from "./paginationPage.vue?vue&type=template&id=2daa7460&scoped=true"
import script from "./paginationPage.vue?vue&type=script&lang=js"
export * from "./paginationPage.vue?vue&type=script&lang=js"
import style0 from "./paginationPage.vue?vue&type=style&index=0&id=2daa7460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa7460",
  null
  
)

export default component.exports